import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

import FieldValue from './FieldValue';
import utils from '../util/utils';

import wowheadIcon from '../icons/wowhead.png';

const skip = new Set([ 'id', 'contributor', 'updated', 'merged', 'currentname', 'currentwowheadid' ]);
const maps = {
    faction: utils.factions,
    covenant: utils.covenants,
    class: utils.classes,
    race: utils.races,
    bind: utils.binds,
    unobtainable: utils.unobtainables,
    missing: utils.noyes,
    excluded: utils.noyes
};
const multiple = {
    class: true,
    race: true
};

function isnull(value) {
    if (value === -1 || value === '-1') return true;
    if (Array.isArray(value) && value.length === 0) return true;
    return false;
}

class Change extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    showJson = (event) => {
        const key = event.currentTarget.getAttribute('data-key');
        this.setState({ ['show' + key]: true });
    }

    render() {
        const summary = [];

        for (let [key, value] of Object.entries(this.props.changes)) {
            if (skip.has(key)) continue;
            if (value === null) continue;

            let change = String(value);
            if (isnull(value)) {
                change = <i>null</i>;
            } else if (maps[key]) {
                change = <FieldValue value={value} map={maps[key]} multiple={multiple[key]} />;
            } else if (key === 'raw' || key === 'tiers' || Array.isArray(value)) {
                if (this.state['show' + key]) {
                    const text = JSON.stringify(value, null, 2);
                    const lines = (text.match(/\n/g) || '').length + 1;
                    change = <textarea readOnly wrap="off" className="w-100 small" rows={lines} value={text}></textarea>;
                } else {
                    change = <button className="btn btn-primary btn-sm" onClick={this.showJson} data-key={key}>Show</button>;
                }
            }

            summary.push({ key, change });
        }

        // format date
        const utc = moment.utc(this.props.changes.updated);
        const local = moment.utc(this.props.changes.updated).local();
        const timestamp = <div>{local.format('ll')} {local.format('LTS')}</div>;
        const tooltip = <><div>{local.format('ll')} {local.format('LTS')} Local Time</div><div>{utc.format('ll')} {utc.format('LTS')} UTC</div></>;
        const canonical = '/collections/' + encodeURIComponent(this.props.category) + '/' + encodeURIComponent(this.props.changes.id) + '/' + encodeURIComponent(utils.canonical(this.props.changes.currentname));

        return (
            <tr>
                {this.props.category ?
                    <td>
                        <a href={utils.wowhead(this.props.category, this.props.changes.currentwowheadid, this.props.changes.id)} target="_blank" rel="noopener noreferrer" className="mr-1">
                            <img src={wowheadIcon} alt="Wowhead Link" style={{ height: '1.5rem', width: '1.5rem' }} />
                        </a>
                        <Link to={canonical} target="_blank" rel="noopener noreferrer">{this.props.changes.currentname}</Link>
                    </td>
                : null}
                <td>
                    <div><Tooltip title={tooltip}>{timestamp}</Tooltip></div>
                    <div className="small">{this.props.changes.contributor}</div>
                    {this.props.changes.merged ? null : <div className="small"><FontAwesomeIcon icon={faExclamationTriangle} className="mr-1" />Not merged</div>}
                </td>
                <td>
                    {summary.map(s => <div key={s.key}>{s.key}: {s.change}</div>)}
                </td>
            </tr>
        );
    }
}

export default Change;